import { useEffect } from 'react'
import { NavLink, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/redux/store'
import { GameRoomStatus } from '@/redux/types/room'
import { getRoomDetails } from '@/redux/asyncThunks/room'
import { ArrowLeftCircle } from 'lucide-react'
import ROUTES from '@/routes/routes'
import RoomNotFound from '@/components/PageNotFound/RoomNotFound'
import GameAnalysisPanel from '@/components/ChatAnalysis/GameAnalysisPanel'
import { UserRole } from '@/constants/room'

const GameAnalysis: React.FC = () => {
  const { roomId = '' } = useParams()
  const dispatch = useDispatch<AppDispatch>()

  const { currentRoom, error } = useSelector((state: RootState) => state.room)
  const userRole = useSelector((state: RootState) => state.user.user?.role)

  useEffect(() => {
    if (roomId) {
      dispatch(getRoomDetails(roomId))
    }
  }, [dispatch, roomId])

  if (error) {
    return <RoomNotFound message='Unable to fetch the room.' />
  }

  if (!currentRoom) {
    return null
  }

  const isGameCompleted = currentRoom.status === GameRoomStatus.COMPLETED
  const isProfessor = userRole === UserRole.Professor

  return (
    <div className='h-full flex flex-col'>
      <div className='w-full px-24 py-5'>
        <div className='flex items-center gap-x-2'>
          <NavLink
            to={ROUTES.PROFESSOR.ROOM_DETAILS(roomId)}
            className='flex-shrink-0'
          >
            <ArrowLeftCircle className='text-dark-blue hover:text-dark-blue-hovered' />
          </NavLink>
          <div>
            <h1 className='text-2xl font-bold text-dark-blue'>Game Analysis</h1>
          </div>
        </div>
      </div>
      <div className='flex-1 overflow-hidden px-24 pb-5'>
        {isGameCompleted && isProfessor ? (
          <GameAnalysisPanel />
        ) : (
          <div className='space-y-3'>
            {!isProfessor && (
              <p className='text-lg text-black'>
                Only professors can access game analysis.
              </p>
            )}
            {!isGameCompleted && (
              <p className='text-lg text-black'>
                Game analysis is only available for completed games.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default GameAnalysis
